// 权限 key 列表
// 如果需要区分大的分类，使用下划线分隔，如样式相关权限配置 style_letterSpacing
// key 与值保持一致
const keys = {
  navbar: 'navbar', // 导航条
  globalSetting: 'globalSetting', // 全局设置
  sceneSetting: 'sceneSetting', // 场景设置
  eventSetting: 'eventSetting', // 事件设置
  gameConfigSetting: 'gameConfigSetting', // 动态参数设置
  viewSwitcher: 'viewSwitcher', // 视图切换器
  languageSelector: 'languageSelector', // 语言选择器
  orientationSelector: 'orientationSelector', // 预览设备方向切换
  playScene: 'playScene', // 播放场景
  addGroup: 'addGroup', // 添加图层组
  toggleLayer: 'toggleLayer', // 切换图层
  estimateSize: 'estimateSize', // 计算包体大小
  recordPrefabImage: 'recordPrefabImage', // 录屏
  capturePrefabImage: 'capturePrefabImage', // 截图
  downloadPrefab: 'downloadPrefab', // 下载预设
  savePrefabImage: 'savePrefabImage', // 保存预设
  createPrefab: 'createPrefab', // 创建预设
  prefabAddParticle: 'prefabAddParticle', // 粒子编辑页添加资产库的粒子
  editTextValue: 'editTextValue', // 编辑文本
  addNode: 'addNode', // 添加节点（包括限制添加资源，因为一般情况下添加节点都需要先添加资源）
  storyBoard: 'storyBoard', // 故事版
  selfDev: 'selfDev', // 自研素材
  customEvent: 'customEvent', // 自定义事件
  box2d: 'box2d',
  categoryVideo: 'categoryVideo', // 插入视频节点
  categoryAudio: 'categoryAudio', // 插入音频节点
  categoryScene: 'categoryScene', // 添加预设场景
  categoryBgm: 'categoryBgm', // 添加背景音乐
  categoryQuickLayout: 'categoryQuickLayout', // 添加快捷布局
  categoryIvUnit: 'categoryIvUnit',
  categoryPlayUnit: 'categoryPlayUnit', // 添加玩法模板
  categoryImage: 'categoryImage',
  categoryText: 'categoryText',
  categoryEffect: 'categoryEffect',
  categoryEmptyNode: 'categoryEmptyNode',
  playUnitInner: 'playUnitInner', // 玩法模板内部操作
  pasteAnimation: 'pasteAnimation', // 粘贴动画
  editAnimation: 'editAnimation', // 编辑动画
  styleUnderline: 'styleUnderline', // 下划线
  styleDeleteLine: 'styleDeleteLine', // 删除线
  styleLetterSpacing: 'styleLetterSpacing', // 字间距
  styleLineHeight: 'styleLineHeight', // 行高
  gameConfigTitleEditable: 'gameConfigTitleEditable',
  gameConfigDescEditable: 'gameConfigDescEditable',
  gameConfigSliderScopeEditable: 'gameConfigSliderScopeEditable',
  playComponentAddElement: 'playComponentAddElement', // 快速排版添加组件元素
  editEventName: 'editEventName', // 编辑事件名称
  editPairCategory: 'editPairCategory', // 打开编辑配对类别弹窗
  addPairRelation: 'addPairRelation', // 新增配对关系按钮
}
export default keys
